var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import { Row } from "react-bootstrap";
import GenericTable from "../../../../../../shared-library/components/GenericTable";
import di from "../../di/serviceLocator";
import { useSelector } from "react-redux";
var RelationColumn = [
    {
        columnName: "EMP Name",
        key: "empName",
    },
    // {
    //data not coming
    //   columnName: "Emp Code",
    //   key: "empCode",
    // },
    {
        columnName: "Role",
        key: "role",
    },
    {
        columnName: "Start Date",
        key: "startDate",
    },
    {
        columnName: "End Date",
        key: "endDate",
    },
];
var RelationShipHistory = function () {
    var _a = __read(React.useState([]), 2), ownerHistoryDataState = _a[0], setOwnerHistoryDataState = _a[1];
    var ownerHistoryData = useSelector(function (state) { return state.Clients.OwnerHistoryReducer.reducersData.data; });
    var selectedAcount = useSelector(function (state) { return state.Clients.ClientSearch.reducersData.selected; });
    React.useEffect(function () {
        if (selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode)
            di.clients.getOwnerHistoryData({ acCode: selectedAcount.accountCode });
    }, [selectedAcount]);
    React.useEffect(function () {
        setOwnerHistoryDataState(ownerHistoryData);
    }, [ownerHistoryData]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, { className: "relationship-head-block mx-0 px-0" },
            React.createElement("div", { className: "DMSanBold_18_700 txt_blackOne1 ps-0" }, "Relationship History")),
        React.createElement(GenericTable, { columns: RelationColumn, data: ownerHistoryDataState, parentClassName: "salestableParentClass", tableClassName: "salestableclass", message: {
                show: (ownerHistoryDataState === null || ownerHistoryDataState === void 0 ? void 0 : ownerHistoryDataState.length) === 0,
                icon: "",
                msg: "No Data Available",
            } })));
};
export default RelationShipHistory;
